import { jsx, jsxs } from 'react/jsx-runtime';
import { Menu, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { SCMenuContainer, SCMenuButton, SCMenuItems } from './styles.js';
const DropdownMenu = _ref => {
  let {
    children
  } = _ref;
  return /* @__PURE__ */jsx(Menu, {
    as: "div",
    children: /* @__PURE__ */jsxs(SCMenuContainer, {
      children: [children, " "]
    })
  });
};
DropdownMenu.Button = SCMenuButton;
DropdownMenu.Menus = _ref2 => {
  let {
    children
  } = _ref2;
  return /* @__PURE__ */jsx(Transition, {
    as: Fragment,
    enter: "transition ease-out duration-100",
    enterFrom: "transform opacity-0 scale-95",
    enterTo: "transform opacity-100 scale-100",
    leave: "transition ease-in duration-75",
    leaveFrom: "transform opacity-100 scale-100",
    leaveTo: "transform opacity-0 scale-95",
    children: /* @__PURE__ */jsx(SCMenuItems, {
      children
    })
  });
};
export { DropdownMenu };